import { createRegex } from "Utils/createRegex";

export const localSearch = ({ text, searchText }) => {
  const searchRegex = createRegex({ text: searchText ?? "", flags: "i" });
  return (text ?? "").search(searchRegex);
};
